module.exports = __webpack_public_path__ + "img/welcome-to-ditto-3.fb2f930e.png";